<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'actorregister.search.businessrole' | translate }}</label>
    <select appSelect [collection]="businessRoleList" formControlName="businessRole"></select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'actorregister.search.name' | translate }}</label>
    <input type="text" appInput formControlName="name" [placeholder]="'actorregister.search.name' | translate">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'actorregister.search.identification' | translate }}</label>
    <input type="text" appInput formControlName="identification" [placeholder]="'actorregister.search.identification' | translate">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'actorregister.search.terminationdate' | translate }}</label>
    <input type="date" appInput formControlName="terminationDate">
  </app-input-group>
</form>
